export default __webpack_public_path__ + "static/media/close.2031443c.svg";